import styled from 'styled-components';

export const KeyRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  color: white;
  padding-bottom: 10px;
`;
